import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MdAiPanelService {
  private _panelOpen = new BehaviorSubject<boolean>(false);
  private _fullscreen = new BehaviorSubject<boolean>(false);

  panelOpen$ = this._panelOpen.asObservable();
  fullscreen$ = this._fullscreen.asObservable();

  get isPanelOpen(): boolean {
    return this._panelOpen.value;
  }

  get isFullscreen(): boolean {
    return this._fullscreen.value;
  }

  togglePanel(): void {
    if (this._panelOpen.value) {
      this.closePanel();
    } else {
      this.openPanel();
    }
  }

  openPanel(): void {
    this._panelOpen.next(true);
  }

  closePanel(): void {
    this._panelOpen.next(false);
    this._fullscreen.next(false);
  }

  toggleFullscreen(): void {
    this._fullscreen.next(!this._fullscreen.value);
  }

  enterFullscreen(): void {
    this._fullscreen.next(true);
  }

  exitFullscreen(): void {
    this._fullscreen.next(false);
  }
}
